var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 2,
    viewBox: "0 0 12 2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5v-1h12v1z",
    fill: "#969696",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3csvg width='12px' height='2px' viewBox='0 0 12 2' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com --%3e %3ctitle%3eIcons / Plus / S Copy%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Inputs-/-Stepper-/-Empty-/-Default' transform='translate(-12.000000, -19.000000)' fill='%23969696'%3e %3cg id='Icons-/-Minus' transform='translate(6.000000, 8.000000)'%3e %3cpolygon id='Line-Copy' transform='translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) ' points='11.5 6 12.5 6 12.5 18 11.5 18'%3e%3c/polygon%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgMinus as ReactComponent };